import { useEffect, useState } from 'react';
import { getCategoryPermissionStatus } from '../../../api/adminAPI';
import { useAdminAPI } from './useAdminAPI';

export interface CategoryPermissionUser {
    userId: number;
    username: string;
    name: string;
    permissionStatus: 'ALL' | 'PARTIAL' | 'NONE';
    role: string;
}

interface CategoryPermissionResponse {
    resultCode: string;
    message: string;
    data: CategoryPermissionUser[];
    total: number;
}

export const useCategoryPermissionStatus = (parentCategoryId?: number) => {
    const { data, loading, error, execute, refetch } = useAdminAPI<CategoryPermissionResponse>(getCategoryPermissionStatus, false);
    // 현재 usersStatus가 어느 parentCategoryId의 데이터인지 추적 (보드 전환 시 stale 데이터 구분용)
    const [loadedParentId, setLoadedParentId] = useState<number | undefined>(undefined);

    useEffect(() => {
        let active = true;

        if (parentCategoryId) {
            execute(parentCategoryId).then((res) => {
                // 요청이 진행되는 동안 parentCategoryId가 바뀌면 오래된 응답은 무시
                if (active && res) setLoadedParentId(parentCategoryId);
            });
        } else {
            setLoadedParentId(undefined);
        }

        return () => {
            active = false;
        };
    }, [parentCategoryId]);

    return {
        usersStatus: data?.data || [],
        loading,
        error,
        loadedParentId,
        refetch: () => parentCategoryId ? execute(parentCategoryId) : Promise.resolve(),
    };
};